/* eslint-disable sonarjs/no-duplicate-string */
import { defineMessages } from "react-intl";
import { useMessages } from "2g-hooks/intl";

const MESSAGES = defineMessages({
  titlePlaceholder: {
    id: "b2b.zdroj-detail.title-placeholder",
    defaultMessage: "Resource"
  },
  messageEmpty: {
    id: "b2b.zdroj-detail.message-empty",
    defaultMessage: "Resource not found"
  }
});

export default () => useMessages(MESSAGES);
